module.exports = __webpack_public_path__ + "static/alessio-945e1ff645d9e1afa4d8a0b95426f521.jpg";